import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';

@Component({
  selector: 'price-field',
  templateUrl: './price-field.component.html',
  styleUrls: ['./price-field.component.scss']
})
export class PriceFieldComponent implements OnInit {

  @Input() price: any;
  @Input() form: any;
  @Input() symbol: string;
  @Input() decimals = 2;
  @Input() max = 999999;
  @Input() min = 0;
  @Input() allownull = true;
  @Input() hidden = false;
  @Input() disabled = false;
  @Input() placeholder = 'Write the price here';

  @Output() validPriceEvent: EventEmitter<any> = new EventEmitter();
  @Input() parentSubject: Subject<any>;

  ngOnInit() {

    if (this.parentSubject) {

      this.parentSubject.subscribe(event => {
        this.price = event;
      });

    }
  }


  priceValid(price: any) {


    if (!price.invalid) {

      this.price = price.string;

    }

    this.validPriceEvent.emit(price);
  }

}
